<template>
  <div class="import-user-with-signin">
    <div class="header">
      <img src="/images/import_with_id.png" />
      <h2>IDとパスワードで作成されたアカウントをインポート</h2>
    </div>
    <div class="signin-block" v-if="!targetAccount">
      <form id='own_signin_form' v-on:submit.prevent="submitForm">
        <div class="signin-input"><label>ログインID</label><input type="text" v-model="accountName"></div>
        <div class="signin-input"><label>パスワード</label><input :type="passwordInputType" id="password" v-model="password"></div>
        <div class="signin_pass_toggle" @click="togglePasswordDisplay">
          <custom-check-box
            :type="'small'"
            :active="passwordDisplay"
            :enabled="true"
          />
          パスワード表示
        </div>
        <button type="submit" class="btn success signin-btn">送信</button>
      </form>
    </div>
    <div class="account-block" v-if="targetAccount">
      <div class="line-item"><span class="title">名前 : </span><span class="value name">{{ targetAccount.name }}</span></div>
      <div class="line-item"><span class="title">ログインID : </span><span class="value">{{ targetAccount.account_name }}</span></div>
      <div class="line-item"><span class="title">メール : </span><span class="value">{{ targetAccount.email }}</span></div>
      <div class="line-item"><span class="title">ナラティブフォンID : </span><span class="value">{{ targetAccount.narrative_phone_id }}</span></div>
      <div class="line-item"><span class="title">Zoom連携 : </span><span class="value">{{ zoomAvailable }}</span></div>
      <div class="line-item"><span class="title">ナラティブブック連携 : </span><span class="value">{{ narrativebookState }}</span></div>
      <div class="controll" v-if="!accountExist"><button @click="executeImport">このアカウントを利用</button></div>
      <div class="message" v-if="accountExist">デバイス登録済み<button @click="executeImport">アカウント情報を再取り込み</button></div>
    </div>
  </div>
</template>

<script>
// import { User } from '@/api' 
import { mapState, mapActions } from 'vuex'

import CustomCheckBox from '@/components/common/CustomCheckBox.vue'

export default {
  name: 'ImportUserWithSignin',

  components: {
    CustomCheckBox,
  },

  emits: [
    'signinSucceedEvent',
    'signinFailedEvent',
  ],

  data () {
    return {
      passwordDisplay: false,
      accountName: '',
      password: '',
      targetAccount: null,
    }
  },

  computed: {
    ...mapState({
      // currentUser: state => state.user.currentUser,
      availableUsers: state => state.user.users,
    }),

    passwordInputType () {
      if (this.passwordDisplay) {
        return 'text'
      } else {
        return 'password'
      }
    },

    zoomAvailable () {
      if (this.targetAccount && this.targetAccount.android_zoom_available || this.targetAccount.ios_zoom_available) {
        return 'Zoom連携済み'
      } else {
        return 'Zoom未連携'
      }
    },

    narrativebookState () {
      if (this.targetAccount && this.targetAccount.nb_organization_id) {
        return '連携済み(施設代表)[' + this.targetAccount.nb_id + ']'
      } else if (/mem.+/g.test(this.targetAccount.nb_uthor_id)) {
        return '連携済み(施設職員)[' + this.targetAccount.nb_id + ']'
      } else if (this.targetAccount.nb_id) {
        return '連携済み(一般利用者)[' + this.targetAccount.nb_id + ']'
      } else {
        return 'ナラティブブック未連携'
      }
    },

    accountType() {
      if (this.targetAccount && this.targetAccount.nb_organization_id) {
        return '施設代表'
      } else if (/mem.+/g.test(this.targetAccount.nb_uthor_id)) {
        return '施設職員'
      } else {
        return '一般利用者'
      }
    },

    accountExist() {
      if (this.targetAccount && this.availableUsers.some((user) => user.id === this.targetAccount.id)) {
        return true
      } else {
        return false
      }
    },
  },

  methods: {
    ...mapActions({
      userSignin: 'user/signin',
    }),

    togglePasswordDisplay () {
      console.log('toggle')
      this.passwordDisplay = !this.passwordDisplay
    },

    submitForm () {
      if (this.accountName.length > 0 && this.password.length > 0) {
        this.userSignin({ accountName: this.accountName, password: this.password }).then(res => {
          console.log('in component')
          console.log(res)
          if (res.data.state === 'success') {
            this.targetAccount = res.data.user
          } else {
            this.$emit('signinFailedEvent')
          }
        }).catch(err => {
          console.error(err)
          this.$emit('signinFailedEvent')
        })
      }
    },

    executeImport () {
      this.$emit('signinSucceedEvent')
    },
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/mediaQuery.scss';
@import '@/assets/css/colorTable.scss';
.import-user-with-signin {
  .header {
    text-align: center;
    h2 {
      margin: 0;
      font-size: 20px;
      color: #666;
    }
  }
  .signin-block {
    margin: 20px auto;
    padding: 20px;
    width: 300px;
    border: 1px solid #aaa;
    text-align: center;
    .signin-input {
      margin: 5px 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      label {
        font-weight: bold;
      }
    }
    .signin_pass_toggle {
      margin: 5px 0;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }
    .signin-btn {
      display: inline-block;
      width: 200px;
      height: 30px;
      margin: 10px auto;
      color: #fff;
      font-weight: bold;
      background-color: $success-color;
      border: none;
      border-radius: 5px;
    }
  }
  .account-block {
    padding: 10px;
    border: 1px solid #ddd;
    .line-item {
      padding: 5px 0;
      .title {
        display: inline-block;
        width: 100px;
        text-align: right;
        font-weight: bold;
      }
      .value {
        font-size: 1.2rem;
      }
    }
    .controll {
      margin-top: 10px;
      text-align: center;
    }
    .message {
      margin-top: 10px;
      text-align: center;
    }
  }
}
</style>